import { render, staticRenderFns } from "./Outfit.vue?vue&type=template&id=bc5f2ae4&scoped=true&"
import script from "./Outfit.vue?vue&type=script&lang=js&"
export * from "./Outfit.vue?vue&type=script&lang=js&"
import style0 from "./Outfit.vue?vue&type=style&index=0&id=bc5f2ae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f2ae4",
  null
  
)

export default component.exports